import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const API = process.env.REACT_APP_BACKEND_URL;

// Wraps /app sub-routes: converted sprint racers who haven't confirmed the
// Season Setup gate are sent back to /app where the gate lives.
export const SeasonGateRedirect = ({ children }) => {
  const navigate = useNavigate();
  useEffect(() => {
    let alive = true;
    fetch(`${API}/api/caddy/season-setup/status`, { credentials: "include" })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (alive && d?.gate_required) navigate("/app", { replace: true }); })
      .catch(() => {});
    return () => { alive = false; };
  }, [navigate]);
  return children;
};
